export const Json = {
  stateList: [
    { label: "阿富汗", value: "AFG" },
    { label: "阿尔巴尼亚", value: "ALB" },
    { label: "阿尔及利亚", value: "DZA" },
    { label: "安道尔", value: "AND" },
    { label: "安哥拉", value: "AGO" },
    { label: "安提瓜和巴布达", value: "ATG" },
    { label: "阿根廷", value: "ARG" },
    { label: "亚美尼亚", value: "ARM" },
    { label: "澳大利亚", value: "AUS" },
    { label: "奥地利", value: "AUT" },
    { label: "阿塞拜疆", value: "AZE" },
    { label: "巴哈马", value: "BHS" },
    { label: "巴林", value: "BHR" },
    { label: "孟加拉", value: "BGD" },
    { label: "巴巴多斯", value: "BRB" },
    { label: "白俄罗斯", value: "BLR" },
    { label: "比利时", value: "BEL" },
    { label: "伯利兹", value: "BLZ" },
    { label: "贝宁", value: "BEN" },
    { label: "百慕大", value: "BMU" },
    { label: "不丹", value: "BTN" },
    { label: "玻利维亚", value: "BOL" },
    { label: "波黑", value: "BIH" },
    { label: "博茨瓦纳", value: "BWA" },
    { label: "巴西", value: "BRA" },
    { label: "英属印度洋领地", value: "IOT" },
    { label: "文莱", value: "BRN" },
    { label: "保加利亚", value: "BGR" },
    { label: "布基纳法索", value: "BFA" },
    { label: "布隆迪", value: "BDI" },
    { label: "柬埔寨", value: "KHM" },
    { label: "喀麦隆", value: "CMR" },
    { label: "加拿大", value: "CAN" },
    { label: "佛得角", value: "CPV" },
    { label: "中非", value: "CAF" },
    { label: "乍得", value: "TCD" },
    { label: "智利", value: "CHL" },
    { label: "中国", value: "CHN" },
    { label: "中国台湾", value: "TWN" },
    { label: "哥伦比亚", value: "COL" },
    { label: "科摩罗", value: "COM" },
    { label: "刚果（布）", value: "COG" },
    { label: "哥斯达黎加", value: "CRI" },
    { label: "科特迪瓦", value: "CIV" },
    { label: "克罗地亚", value: "HRV" },
    { label: "古巴", value: "CUB" },
    { label: "塞浦路斯", value: "CYP" },
    { label: "捷克", value: "CZE" },
    { label: "丹麦", value: "DNK" },
    { label: "吉布提", value: "DJI" },
    { label: "多米尼克", value: "DMA" },
    { label: "多米尼克", value: "DOM" },
    { label: "厄瓜多尔", value: "ECU" },
    { label: "埃及", value: "EGY" },
    { label: "萨尔瓦多", value: "SLV" },
    { label: "赤道几内亚", value: "GNQ" },
    { label: "厄立特里亚", value: "ERI" },
    { label: "爱沙尼亚", value: "EST" },
    { label: "埃塞俄比亚", value: "ETH" },
    { label: "斐济群岛", value: "FJI" },
    { label: "芬兰", value: "FIN" },
    { label: "法国", value: "FRA" },
    { label: "加蓬", value: "GAB" },
    { label: "冈比亚", value: "GMB" },
    { label: "格鲁吉亚", value: "GEO" },
    { label: "德国", value: "D" },
    { label: "加纳", value: "GHA" },
    { label: "直布罗陀", value: "GIB" },
    { label: "希腊", value: "GRC" },
    { label: "格陵兰", value: "GRL" },
    { label: "格林纳达", value: "GRD" },
    { label: "危地马拉", value: "GTM" },
    { label: "几内亚", value: "GIN" },
    { label: "几内亚比绍", value: "GNB" },
    { label: "圭亚那", value: "GUY" },
    { label: "海地", value: "HTI" },
    { label: "梵蒂冈", value: "VAT" },
    { label: "洪都拉斯", value: "HND" },
    { label: "匈牙利", value: "HUN" },
    { label: "冰岛", value: "ISL" },
    { label: "印度", value: "IND" },
    { label: "印尼", value: "IDN" },
    { label: "伊朗", value: "IRN" },
    { label: "伊拉克", value: "IRQ" },
    { label: "爱尔兰", value: "IRL" },
    { label: "以色列", value: "ISR" },
    { label: "意大利", value: "ITA" },
    { label: "牙买加", value: "JAM" },
    { label: "日本", value: "JPN" },
    { label: "约旦", value: "JOR" },
    { label: "哈萨克斯坦", value: "KAZ" },
    { label: "肯尼亚", value: "KEN" },
    { label: "基里巴斯", value: "KIR" },
    { label: "韩国；", value: "KOR" },
    { label: "朝鲜；", value: "PRK" },
    { label: "科索沃共和国", value: "RKS" },
    { label: "科威特", value: "KWT" },
    { label: "吉尔吉斯斯坦", value: "KGZ" },
    { label: "老挝", value: "LAO" },
    { label: "拉脱维亚", value: "LVA" },
    { label: "黎巴嫩", value: "LBN" },
    { label: "莱索托", value: "LSO" },
    { label: "利比里亚", value: "LBR" },
    { label: "利比亚", value: "LBY" },
    { label: "列支敦士登", value: "LIE" },
    { label: "立陶宛", value: "LTU" },
    { label: "卢森堡", value: "LUX" },
    { label: "马其顿", value: "MKD" },
    { label: "马达加斯加", value: "MDG" },
    { label: "马拉维", value: "MWI" },
    { label: "马来西亚", value: "MYS" },
    { label: "马尔代夫", value: "MDV" },
    { label: "马里", value: "MLI" },
    { label: "马耳他", value: "MLT" },
    { label: "马绍尔群岛", value: "MHL" },
    { label: "毛里塔尼亚", value: "MRT" },
    { label: "毛里求斯", value: "MUS" },
    { label: "墨西哥", value: "MEX" },
    { label: "密克罗尼西亚联邦", value: "FSM" },
    { label: "摩尔多瓦", value: "MDA" },
    { label: "摩纳哥", value: "MCO" },
    { label: "蒙古国；蒙古", value: "MNG" },
    { label: "黑山", value: "MNE" },
    { label: "蒙塞拉特岛", value: "MSR" },
    { label: "摩洛哥", value: "MAR" },
    { label: "莫桑比克", value: "MOZ" },
    { label: "缅甸", value: "MMR" },
    { label: "纳米比亚", value: "NAM" },
    { label: "瑙鲁", value: "NRU" },
    { label: "尼泊尔", value: "NPL" },
    { label: "荷兰", value: "NLD" },
    { label: "新西兰", value: "NZL" },
    { label: "尼加拉瓜", value: "NIC" },
    { label: "尼日尔", value: "NER" },
    { label: "尼日利亚", value: "NGA" },
    { label: "挪威", value: "NOR" },
    { label: "阿曼", value: "OMN" },
    { label: "巴基斯坦", value: "PAK" },
    { label: "帕劳", value: "PLW" },
    { label: "巴勒斯坦", value: "PSE" },
    { label: "巴拿马", value: "PAN" },
    { label: "巴布亚新几内亚", value: "PNG" },
    { label: "巴拉圭", value: "PRY" },
    { label: "秘鲁", value: "PER" },
    { label: "菲律宾", value: "PHL" },
    { label: "波兰", value: "POL" },
    { label: "葡萄牙", value: "PRT" },
    { label: "卡塔尔", value: "QAT" },
    { label: "罗马尼亚", value: "ROU" },
    { label: "俄罗斯", value: "RUS" },
    { label: "卢旺达", value: "RWA" },
    { label: "圣基茨和尼维斯", value: "KNA" },
    { label: "圣卢西亚", value: "LCA" },
    { label: "圣文森特和格林纳丁斯", value: "VCT" },
    { label: "圣马力诺", value: "SMR" },
    { label: "圣多美和普林西比", value: "STP" },
    { label: "沙特阿拉伯", value: "SAU" },
    { label: "苏格兰", value: "SC-" },
    { label: "塞内加尔", value: "SEN" },
    { label: "塞尔维亚", value: "SRB" },
    { label: "塞舌尔", value: "SYC" },
    { label: "塞拉利昂", value: "SLE" },
    { label: "新加坡", value: "SGP" },
    { label: "斯洛伐克", value: "SVK" },
    { label: "斯洛文尼亚", value: "SVN" },
    { label: "所罗门群岛", value: "SLB" },
    { label: "索马里", value: "SOM" },
    { label: "南非", value: "ZAF" },
    { label: "西班牙", value: "ESP" },
    { label: "斯里兰卡", value: "LKA" },
    { label: "苏丹", value: "SDN" },
    { label: "苏里南", value: "SUR" },
    { label: "斯威士兰", value: "SWZ" },
    { label: "瑞典", value: "SWE" },
    { label: "瑞士", value: "CHE" },
    { label: "叙利亚", value: "SYR" },
    { label: "塔吉克斯坦", value: "TJK" },
    { label: "坦桑尼亚", value: "TZA" },
    { label: "泰国", value: "THA" },
    { label: "东帝汶", value: "TLS" },
    { label: "多哥", value: "TGO" },
    { label: "汤加", value: "TON" },
    { label: "特立尼达和多巴哥", value: "TTO" },
    { label: "突尼斯", value: "TUN" },
    { label: "土耳其", value: "TUR" },
    { label: "土库曼斯坦", value: "TKM" },
    { label: "图瓦卢", value: "TUV" },
    { label: "乌干达", value: "UGA" },
    { label: "乌克兰", value: "UKR" },
    { label: "阿联酋", value: "ARE" },
    { label: "英联邦", value: "GBD" },
    { label: "英国", value: "GBR" },
    { label: "联合国组织", value: "UNO" },
    { label: "美国", value: "USA" },
    { label: "乌拉圭", value: "URY" },
    { label: "乌兹别克斯坦", value: "UZB" },
    { label: "瓦努阿图", value: "VUT" },
    { label: "委内瑞拉", value: "VEN" },
    { label: "萨摩亚", value: "WSM" },
    { label: "也门", value: "YEM" },
    { label: "赞比亚", value: "ZMB" },
    { label: "津巴布韦", value: "ZWE" }
  ],
  provincesCityList: [
		{
			"text": "北京市",
			"value": "110000",
			"children": [
				{
					"text": "东城区",
					"value": "110101"
				},
				{
					"text": "西城区",
					"value": "110102"
				},
				{
					"text": "朝阳区",
					"value": "110105"
				},
				{
					"text": "丰台区",
					"value": "110106"
				},
				{
					"text": "石景山区",
					"value": "110107"
				},
				{
					"text": "海淀区",
					"value": "110108"
				},
				{
					"text": "门头沟区",
					"value": "110109"
				},
				{
					"text": "房山区",
					"value": "110111"
				},
				{
					"text": "通州区",
					"value": "110112"
				},
				{
					"text": "顺义区",
					"value": "110113"
				},
				{
					"text": "昌平区",
					"value": "110114"
				},
				{
					"text": "大兴区",
					"value": "110115"
				},
				{
					"text": "怀柔区",
					"value": "110116"
				},
				{
					"text": "平谷区",
					"value": "110117"
				},
				{
					"text": "密云区",
					"value": "110118"
				},
				{
					"text": "延庆区",
					"value": "110119"
				}
			]
		},
		{
			"text": "天津市",
			"value": "120000",
			"children": [
				{
					"text": "和平区",
					"value": "120101"
				},
				{
					"text": "河东区",
					"value": "120102"
				},
				{
					"text": "河西区",
					"value": "120103"
				},
				{
					"text": "南开区",
					"value": "120104"
				},
				{
					"text": "河北区",
					"value": "120105"
				},
				{
					"text": "红桥区",
					"value": "120106"
				},
				{
					"text": "东丽区",
					"value": "120110"
				},
				{
					"text": "西青区",
					"value": "120111"
				},
				{
					"text": "津南区",
					"value": "120112"
				},
				{
					"text": "北辰区",
					"value": "120113"
				},
				{
					"text": "武清区",
					"value": "120114"
				},
				{
					"text": "宝坻区",
					"value": "120115"
				},
				{
					"text": "滨海新区",
					"value": "120116"
				},
				{
					"text": "宁河区",
					"value": "120117"
				},
				{
					"text": "静海区",
					"value": "120118"
				},
				{
					"text": "蓟州区",
					"value": "120119"
				}
			]
		},
		{
			"text": "河北省",
			"value": "130000",
			"children": [
				{
					"text": "石家庄市",
					"value": "130100"
				},
				{
					"text": "唐山市",
					"value": "130200"
				},
				{
					"text": "秦皇岛市",
					"value": "130300"
				},
				{
					"text": "邯郸市",
					"value": "130400"
				},
				{
					"text": "邢台市",
					"value": "130500"
				},
				{
					"text": "保定市",
					"value": "130600"
				},
				{
					"text": "张家口市",
					"value": "130700"
				},
				{
					"text": "承德市",
					"value": "130800"
				},
				{
					"text": "沧州市",
					"value": "130900"
				},
				{
					"text": "廊坊市",
					"value": "131000"
				},
				{
					"text": "衡水市",
					"value": "131100"
				}
			]
		},
		{
			"text": "山西省",
			"value": "140000",
			"children": [
				{
					"text": "太原市",
					"value": "140100"
				},
				{
					"text": "大同市",
					"value": "140200"
				},
				{
					"text": "阳泉市",
					"value": "140300"
				},
				{
					"text": "长治市",
					"value": "140400"
				},
				{
					"text": "晋城市",
					"value": "140500"
				},
				{
					"text": "朔州市",
					"value": "140600"
				},
				{
					"text": "晋中市",
					"value": "140700"
				},
				{
					"text": "运城市",
					"value": "140800"
				},
				{
					"text": "忻州市",
					"value": "140900"
				},
				{
					"text": "临汾市",
					"value": "141000"
				},
				{
					"text": "吕梁市",
					"value": "141100"
				}
			]
		},
		{
			"text": "内蒙古自治区",
			"value": "150000",
			"children": [
				{
					"text": "呼和浩特市",
					"value": "150100"
				},
				{
					"text": "包头市",
					"value": "150200"
				},
				{
					"text": "乌海市",
					"value": "150300"
				},
				{
					"text": "赤峰市",
					"value": "150400"
				},
				{
					"text": "通辽市",
					"value": "150500"
				},
				{
					"text": "鄂尔多斯市",
					"value": "150600"
				},
				{
					"text": "呼伦贝尔市",
					"value": "150700"
				},
				{
					"text": "巴彦淖尔市",
					"value": "150800"
				},
				{
					"text": "乌兰察布市",
					"value": "150900"
				},
				{
					"text": "兴安盟",
					"value": "152200"
				},
				{
					"text": "锡林郭勒盟",
					"value": "152500"
				},
				{
					"text": "阿拉善盟",
					"value": "152900"
				}
			]
		},
		{
			"text": "辽宁省",
			"value": "210000",
			"children": [
				{
					"text": "沈阳市",
					"value": "210100"
				},
				{
					"text": "大连市",
					"value": "210200"
				},
				{
					"text": "鞍山市",
					"value": "210300"
				},
				{
					"text": "抚顺市",
					"value": "210400"
				},
				{
					"text": "本溪市",
					"value": "210500"
				},
				{
					"text": "丹东市",
					"value": "210600"
				},
				{
					"text": "锦州市",
					"value": "210700"
				},
				{
					"text": "营口市",
					"value": "210800"
				},
				{
					"text": "阜新市",
					"value": "210900"
				},
				{
					"text": "辽阳市",
					"value": "211000"
				},
				{
					"text": "盘锦市",
					"value": "211100"
				},
				{
					"text": "铁岭市",
					"value": "211200"
				},
				{
					"text": "朝阳市",
					"value": "211300"
				},
				{
					"text": "葫芦岛市",
					"value": "211400"
				}
			]
		},
		{
			"text": "吉林省",
			"value": "220000",
			"children": [
				{
					"text": "长春市",
					"value": "220100"
				},
				{
					"text": "吉林市",
					"value": "220200"
				},
				{
					"text": "四平市",
					"value": "220300"
				},
				{
					"text": "辽源市",
					"value": "220400"
				},
				{
					"text": "通化市",
					"value": "220500"
				},
				{
					"text": "白山市",
					"value": "220600"
				},
				{
					"text": "松原市",
					"value": "220700"
				},
				{
					"text": "白城市",
					"value": "220800"
				},
				{
					"text": "延边朝鲜族自治州",
					"value": "222400"
				}
			]
		},
		{
			"text": "黑龙江省",
			"value": "230000",
			"children": [
				{
					"text": "哈尔滨市",
					"value": "230100"
				},
				{
					"text": "齐齐哈尔市",
					"value": "230200"
				},
				{
					"text": "鸡西市",
					"value": "230300"
				},
				{
					"text": "鹤岗市",
					"value": "230400"
				},
				{
					"text": "双鸭山市",
					"value": "230500"
				},
				{
					"text": "大庆市",
					"value": "230600"
				},
				{
					"text": "伊春市",
					"value": "230700"
				},
				{
					"text": "佳木斯市",
					"value": "230800"
				},
				{
					"text": "七台河市",
					"value": "230900"
				},
				{
					"text": "牡丹江市",
					"value": "231000"
				},
				{
					"text": "黑河市",
					"value": "231100"
				},
				{
					"text": "绥化市",
					"value": "231200"
				},
				{
					"text": "大兴安岭地区",
					"value": "232700"
				}
			]
		},
		{
			"text": "上海市",
			"value": "310000",
			"children": [
				{
					"text": "黄浦区",
					"value": "310101"
				},
				{
					"text": "徐汇区",
					"value": "310104"
				},
				{
					"text": "长宁区",
					"value": "310105"
				},
				{
					"text": "静安区",
					"value": "310106"
				},
				{
					"text": "普陀区",
					"value": "310107"
				},
				{
					"text": "虹口区",
					"value": "310109"
				},
				{
					"text": "杨浦区",
					"value": "310110"
				},
				{
					"text": "闵行区",
					"value": "310112"
				},
				{
					"text": "宝山区",
					"value": "310113"
				},
				{
					"text": "嘉定区",
					"value": "310114"
				},
				{
					"text": "浦东新区",
					"value": "310115"
				},
				{
					"text": "金山区",
					"value": "310116"
				},
				{
					"text": "松江区",
					"value": "310117"
				},
				{
					"text": "青浦区",
					"value": "310118"
				},
				{
					"text": "奉贤区",
					"value": "310120"
				},
				{
					"text": "崇明区",
					"value": "310151"
				}
			]
		},
		{
			"text": "江苏省",
			"value": "320000",
			"children": [
				{
					"text": "南京市",
					"value": "320100"
				},
				{
					"text": "无锡市",
					"value": "320200"
				},
				{
					"text": "徐州市",
					"value": "320300"
				},
				{
					"text": "常州市",
					"value": "320400"
				},
				{
					"text": "苏州市",
					"value": "320500"
				},
				{
					"text": "南通市",
					"value": "320600"
				},
				{
					"text": "连云港市",
					"value": "320700"
				},
				{
					"text": "淮安市",
					"value": "320800"
				},
				{
					"text": "盐城市",
					"value": "320900"
				},
				{
					"text": "扬州市",
					"value": "321000"
				},
				{
					"text": "镇江市",
					"value": "321100"
				},
				{
					"text": "泰州市",
					"value": "321200"
				},
				{
					"text": "宿迁市",
					"value": "321300"
				}
			]
		},
		{
			"text": "浙江省",
			"value": "330000",
			"children": [
				{
					"text": "杭州市",
					"value": "330100"
				},
				{
					"text": "宁波市",
					"value": "330200"
				},
				{
					"text": "温州市",
					"value": "330300"
				},
				{
					"text": "嘉兴市",
					"value": "330400"
				},
				{
					"text": "湖州市",
					"value": "330500"
				},
				{
					"text": "绍兴市",
					"value": "330600"
				},
				{
					"text": "金华市",
					"value": "330700"
				},
				{
					"text": "衢州市",
					"value": "330800"
				},
				{
					"text": "舟山市",
					"value": "330900"
				},
				{
					"text": "台州市",
					"value": "331000"
				},
				{
					"text": "丽水市",
					"value": "331100"
				}
			]
		},
		{
			"text": "安徽省",
			"value": "340000",
			"children": [
				{
					"text": "合肥市",
					"value": "340100"
				},
				{
					"text": "芜湖市",
					"value": "340200"
				},
				{
					"text": "蚌埠市",
					"value": "340300"
				},
				{
					"text": "淮南市",
					"value": "340400"
				},
				{
					"text": "马鞍山市",
					"value": "340500"
				},
				{
					"text": "淮北市",
					"value": "340600"
				},
				{
					"text": "铜陵市",
					"value": "340700"
				},
				{
					"text": "安庆市",
					"value": "340800"
				},
				{
					"text": "黄山市",
					"value": "341000"
				},
				{
					"text": "滁州市",
					"value": "341100"
				},
				{
					"text": "阜阳市",
					"value": "341200"
				},
				{
					"text": "宿州市",
					"value": "341300"
				},
				{
					"text": "六安市",
					"value": "341500"
				},
				{
					"text": "亳州市",
					"value": "341600"
				},
				{
					"text": "池州市",
					"value": "341700"
				},
				{
					"text": "宣城市",
					"value": "341800"
				}
			]
		},
		{
			"text": "福建省",
			"value": "350000",
			"children": [
				{
					"text": "福州市",
					"value": "350100"
				},
				{
					"text": "厦门市",
					"value": "350200"
				},
				{
					"text": "莆田市",
					"value": "350300"
				},
				{
					"text": "三明市",
					"value": "350400"
				},
				{
					"text": "泉州市",
					"value": "350500"
				},
				{
					"text": "漳州市",
					"value": "350600"
				},
				{
					"text": "南平市",
					"value": "350700"
				},
				{
					"text": "龙岩市",
					"value": "350800"
				},
				{
					"text": "宁德市",
					"value": "350900"
				}
			]
		},
		{
			"text": "江西省",
			"value": "360000",
			"children": [
				{
					"text": "南昌市",
					"value": "360100"
				},
				{
					"text": "景德镇市",
					"value": "360200"
				},
				{
					"text": "萍乡市",
					"value": "360300"
				},
				{
					"text": "九江市",
					"value": "360400"
				},
				{
					"text": "新余市",
					"value": "360500"
				},
				{
					"text": "鹰潭市",
					"value": "360600"
				},
				{
					"text": "赣州市",
					"value": "360700"
				},
				{
					"text": "吉安市",
					"value": "360800"
				},
				{
					"text": "宜春市",
					"value": "360900"
				},
				{
					"text": "抚州市",
					"value": "361000"
				},
				{
					"text": "上饶市",
					"value": "361100"
				}
			]
		},
		{
			"text": "山东省",
			"value": "370000",
			"children": [
				{
					"text": "济南市",
					"value": "370100"
				},
				{
					"text": "青岛市",
					"value": "370200"
				},
				{
					"text": "淄博市",
					"value": "370300"
				},
				{
					"text": "枣庄市",
					"value": "370400"
				},
				{
					"text": "东营市",
					"value": "370500"
				},
				{
					"text": "烟台市",
					"value": "370600"
				},
				{
					"text": "潍坊市",
					"value": "370700"
				},
				{
					"text": "济宁市",
					"value": "370800"
				},
				{
					"text": "泰安市",
					"value": "370900"
				},
				{
					"text": "威海市",
					"value": "371000"
				},
				{
					"text": "日照市",
					"value": "371100"
				},
				{
					"text": "临沂市",
					"value": "371300"
				},
				{
					"text": "德州市",
					"value": "371400"
				},
				{
					"text": "聊城市",
					"value": "371500"
				},
				{
					"text": "滨州市",
					"value": "371600"
				},
				{
					"text": "菏泽市",
					"value": "371700"
				}
			]
		},
		{
			"text": "河南省",
			"value": "410000",
			"children": [
				{
					"text": "郑州市",
					"value": "410100"
				},
				{
					"text": "开封市",
					"value": "410200"
				},
				{
					"text": "洛阳市",
					"value": "410300"
				},
				{
					"text": "平顶山市",
					"value": "410400"
				},
				{
					"text": "安阳市",
					"value": "410500"
				},
				{
					"text": "鹤壁市",
					"value": "410600"
				},
				{
					"text": "新乡市",
					"value": "410700"
				},
				{
					"text": "焦作市",
					"value": "410800"
				},
				{
					"text": "濮阳市",
					"value": "410900"
				},
				{
					"text": "许昌市",
					"value": "411000"
				},
				{
					"text": "漯河市",
					"value": "411100"
				},
				{
					"text": "三门峡市",
					"value": "411200"
				},
				{
					"text": "南阳市",
					"value": "411300"
				},
				{
					"text": "商丘市",
					"value": "411400"
				},
				{
					"text": "信阳市",
					"value": "411500"
				},
				{
					"text": "周口市",
					"value": "411600"
				},
				{
					"text": "驻马店市",
					"value": "411700"
				},
				{
					"text": "济源市",
					"value": "419001"
				}
			]
		},
		{
			"text": "湖北省",
			"value": "420000",
			"children": [
				{
					"text": "武汉市",
					"value": "420100"
				},
				{
					"text": "黄石市",
					"value": "420200"
				},
				{
					"text": "十堰市",
					"value": "420300"
				},
				{
					"text": "宜昌市",
					"value": "420500"
				},
				{
					"text": "襄阳市",
					"value": "420600"
				},
				{
					"text": "鄂州市",
					"value": "420700"
				},
				{
					"text": "荆门市",
					"value": "420800"
				},
				{
					"text": "孝感市",
					"value": "420900"
				},
				{
					"text": "荆州市",
					"value": "421000"
				},
				{
					"text": "黄冈市",
					"value": "421100"
				},
				{
					"text": "咸宁市",
					"value": "421200"
				},
				{
					"text": "随州市",
					"value": "421300"
				},
				{
					"text": "恩施土家族苗族自治州",
					"value": "422800"
				},
				{
					"text": "仙桃市",
					"value": "429004"
				},
				{
					"text": "潜江市",
					"value": "429005"
				},
				{
					"text": "天门市",
					"value": "429006"
				},
				{
					"text": "神农架林区",
					"value": "429021"
				}
			]
		},
		{
			"text": "湖南省",
			"value": "430000",
			"children": [
				{
					"text": "长沙市",
					"value": "430100"
				},
				{
					"text": "株洲市",
					"value": "430200"
				},
				{
					"text": "湘潭市",
					"value": "430300"
				},
				{
					"text": "衡阳市",
					"value": "430400"
				},
				{
					"text": "邵阳市",
					"value": "430500"
				},
				{
					"text": "岳阳市",
					"value": "430600"
				},
				{
					"text": "常德市",
					"value": "430700"
				},
				{
					"text": "张家界市",
					"value": "430800"
				},
				{
					"text": "益阳市",
					"value": "430900"
				},
				{
					"text": "郴州市",
					"value": "431000"
				},
				{
					"text": "永州市",
					"value": "431100"
				},
				{
					"text": "怀化市",
					"value": "431200"
				},
				{
					"text": "娄底市",
					"value": "431300"
				},
				{
					"text": "湘西土家族苗族自治州",
					"value": "433100"
				}
			]
		},
		{
			"text": "广东省",
			"value": "440000",
			"children": [
				{
					"text": "广州市",
					"value": "440100"
				},
				{
					"text": "韶关市",
					"value": "440200"
				},
				{
					"text": "深圳市",
					"value": "440300"
				},
				{
					"text": "珠海市",
					"value": "440400"
				},
				{
					"text": "汕头市",
					"value": "440500"
				},
				{
					"text": "佛山市",
					"value": "440600"
				},
				{
					"text": "江门市",
					"value": "440700"
				},
				{
					"text": "湛江市",
					"value": "440800"
				},
				{
					"text": "茂名市",
					"value": "440900"
				},
				{
					"text": "肇庆市",
					"value": "441200"
				},
				{
					"text": "惠州市",
					"value": "441300"
				},
				{
					"text": "梅州市",
					"value": "441400"
				},
				{
					"text": "汕尾市",
					"value": "441500"
				},
				{
					"text": "河源市",
					"value": "441600"
				},
				{
					"text": "阳江市",
					"value": "441700"
				},
				{
					"text": "清远市",
					"value": "441800"
				},
				{
					"text": "东莞市",
					"value": "441900"
				},
				{
					"text": "中山市",
					"value": "442000"
				},
				{
					"text": "潮州市",
					"value": "445100"
				},
				{
					"text": "揭阳市",
					"value": "445200"
				},
				{
					"text": "云浮市",
					"value": "445300"
				}
			]
		},
		{
			"text": "广西壮族自治区",
			"value": "450000",
			"children": [
				{
					"text": "南宁市",
					"value": "450100"
				},
				{
					"text": "柳州市",
					"value": "450200"
				},
				{
					"text": "桂林市",
					"value": "450300"
				},
				{
					"text": "梧州市",
					"value": "450400"
				},
				{
					"text": "北海市",
					"value": "450500"
				},
				{
					"text": "防城港市",
					"value": "450600"
				},
				{
					"text": "钦州市",
					"value": "450700"
				},
				{
					"text": "贵港市",
					"value": "450800"
				},
				{
					"text": "玉林市",
					"value": "450900"
				},
				{
					"text": "百色市",
					"value": "451000"
				},
				{
					"text": "贺州市",
					"value": "451100"
				},
				{
					"text": "河池市",
					"value": "451200"
				},
				{
					"text": "来宾市",
					"value": "451300"
				},
				{
					"text": "崇左市",
					"value": "451400"
				}
			]
		},
		{
			"text": "海南省",
			"value": "460000",
			"children": [
				{
					"text": "海口市",
					"value": "460100"
				},
				{
					"text": "三亚市",
					"value": "460200"
				},
				{
					"text": "三沙市",
					"value": "460300"
				},
				{
					"text": "儋州市",
					"value": "460400"
				},
				{
					"text": "五指山市",
					"value": "469001"
				},
				{
					"text": "琼海市",
					"value": "469002"
				},
				{
					"text": "文昌市",
					"value": "469005"
				},
				{
					"text": "万宁市",
					"value": "469006"
				},
				{
					"text": "东方市",
					"value": "469007"
				},
				{
					"text": "定安县",
					"value": "469021"
				},
				{
					"text": "屯昌县",
					"value": "469022"
				},
				{
					"text": "澄迈县",
					"value": "469023"
				},
				{
					"text": "临高县",
					"value": "469024"
				},
				{
					"text": "白沙黎族自治县",
					"value": "469025"
				},
				{
					"text": "昌江黎族自治县",
					"value": "469026"
				},
				{
					"text": "乐东黎族自治县",
					"value": "469027"
				},
				{
					"text": "陵水黎族自治县",
					"value": "469028"
				},
				{
					"text": "保亭黎族苗族自治县",
					"value": "469029"
				},
				{
					"text": "琼中黎族苗族自治县",
					"value": "469030"
				}
			]
		},
		{
			"text": "重庆市",
			"value": "500000",
			"children": [
				{
					"text": "万州区",
					"value": "500101"
				},
				{
					"text": "涪陵区",
					"value": "500102"
				},
				{
					"text": "渝中区",
					"value": "500103"
				},
				{
					"text": "大渡口区",
					"value": "500104"
				},
				{
					"text": "江北区",
					"value": "500105"
				},
				{
					"text": "沙坪坝区",
					"value": "500106"
				},
				{
					"text": "九龙坡区",
					"value": "500107"
				},
				{
					"text": "南岸区",
					"value": "500108"
				},
				{
					"text": "北碚区",
					"value": "500109"
				},
				{
					"text": "綦江区",
					"value": "500110"
				},
				{
					"text": "大足区",
					"value": "500111"
				},
				{
					"text": "渝北区",
					"value": "500112"
				},
				{
					"text": "巴南区",
					"value": "500113"
				},
				{
					"text": "黔江区",
					"value": "500114"
				},
				{
					"text": "长寿区",
					"value": "500115"
				},
				{
					"text": "江津区",
					"value": "500116"
				},
				{
					"text": "合川区",
					"value": "500117"
				},
				{
					"text": "永川区",
					"value": "500118"
				},
				{
					"text": "南川区",
					"value": "500119"
				},
				{
					"text": "璧山区",
					"value": "500120"
				},
				{
					"text": "铜梁区",
					"value": "500151"
				},
				{
					"text": "潼南区",
					"value": "500152"
				},
				{
					"text": "荣昌区",
					"value": "500153"
				},
				{
					"text": "开州区",
					"value": "500154"
				},
				{
					"text": "梁平区",
					"value": "500155"
				},
				{
					"text": "武隆区",
					"value": "500156"
				},
				{
					"text": "城口县",
					"value": "500229"
				},
				{
					"text": "丰都县",
					"value": "500230"
				},
				{
					"text": "垫江县",
					"value": "500231"
				},
				{
					"text": "忠县",
					"value": "500233"
				},
				{
					"text": "云阳县",
					"value": "500235"
				},
				{
					"text": "奉节县",
					"value": "500236"
				},
				{
					"text": "巫山县",
					"value": "500237"
				},
				{
					"text": "巫溪县",
					"value": "500238"
				},
				{
					"text": "石柱土家族自治县",
					"value": "500240"
				},
				{
					"text": "秀山土家族苗族自治县",
					"value": "500241"
				},
				{
					"text": "酉阳土家族苗族自治县",
					"value": "500242"
				},
				{
					"text": "彭水苗族土家族自治县",
					"value": "500243"
				}
			]
		},
		{
			"text": "四川省",
			"value": "510000",
			"children": [
				{
					"text": "成都市",
					"value": "510100"
				},
				{
					"text": "自贡市",
					"value": "510300"
				},
				{
					"text": "攀枝花市",
					"value": "510400"
				},
				{
					"text": "泸州市",
					"value": "510500"
				},
				{
					"text": "德阳市",
					"value": "510600"
				},
				{
					"text": "绵阳市",
					"value": "510700"
				},
				{
					"text": "广元市",
					"value": "510800"
				},
				{
					"text": "遂宁市",
					"value": "510900"
				},
				{
					"text": "内江市",
					"value": "511000"
				},
				{
					"text": "乐山市",
					"value": "511100"
				},
				{
					"text": "南充市",
					"value": "511300"
				},
				{
					"text": "眉山市",
					"value": "511400"
				},
				{
					"text": "宜宾市",
					"value": "511500"
				},
				{
					"text": "广安市",
					"value": "511600"
				},
				{
					"text": "达州市",
					"value": "511700"
				},
				{
					"text": "雅安市",
					"value": "511800"
				},
				{
					"text": "巴中市",
					"value": "511900"
				},
				{
					"text": "资阳市",
					"value": "512000"
				},
				{
					"text": "阿坝藏族羌族自治州",
					"value": "513200"
				},
				{
					"text": "甘孜藏族自治州",
					"value": "513300"
				},
				{
					"text": "凉山彝族自治州",
					"value": "513400"
				}
			]
		},
		{
			"text": "贵州省",
			"value": "520000",
			"children": [
				{
					"text": "贵阳市",
					"value": "520100"
				},
				{
					"text": "六盘水市",
					"value": "520200"
				},
				{
					"text": "遵义市",
					"value": "520300"
				},
				{
					"text": "安顺市",
					"value": "520400"
				},
				{
					"text": "毕节市",
					"value": "520500"
				},
				{
					"text": "铜仁市",
					"value": "520600"
				},
				{
					"text": "黔西南布依族苗族自治州",
					"value": "522300"
				},
				{
					"text": "黔东南苗族侗族自治州",
					"value": "522600"
				},
				{
					"text": "黔南布依族苗族自治州",
					"value": "522700"
				}
			]
		},
		{
			"text": "云南省",
			"value": "530000",
			"children": [
				{
					"text": "昆明市",
					"value": "530100"
				},
				{
					"text": "曲靖市",
					"value": "530300"
				},
				{
					"text": "玉溪市",
					"value": "530400"
				},
				{
					"text": "保山市",
					"value": "530500"
				},
				{
					"text": "昭通市",
					"value": "530600"
				},
				{
					"text": "丽江市",
					"value": "530700"
				},
				{
					"text": "普洱市",
					"value": "530800"
				},
				{
					"text": "临沧市",
					"value": "530900"
				},
				{
					"text": "楚雄彝族自治州",
					"value": "532300"
				},
				{
					"text": "红河哈尼族彝族自治州",
					"value": "532500"
				},
				{
					"text": "文山壮族苗族自治州",
					"value": "532600"
				},
				{
					"text": "西双版纳傣族自治州",
					"value": "532800"
				},
				{
					"text": "大理白族自治州",
					"value": "532900"
				},
				{
					"text": "德宏傣族景颇族自治州",
					"value": "533100"
				},
				{
					"text": "怒江傈僳族自治州",
					"value": "533300"
				},
				{
					"text": "迪庆藏族自治州",
					"value": "533400"
				}
			]
		},
		{
			"text": "西藏自治区",
			"value": "540000",
			"children": [
				{
					"text": "拉萨市",
					"value": "540100"
				},
				{
					"text": "日喀则市",
					"value": "540200"
				},
				{
					"text": "昌都市",
					"value": "540300"
				},
				{
					"text": "林芝市",
					"value": "540400"
				},
				{
					"text": "山南市",
					"value": "540500"
				},
				{
					"text": "那曲市",
					"value": "540600"
				},
				{
					"text": "阿里地区",
					"value": "542500"
				}
			]
		},
		{
			"text": "陕西省",
			"value": "610000",
			"children": [
				{
					"text": "西安市",
					"value": "610100"
				},
				{
					"text": "铜川市",
					"value": "610200"
				},
				{
					"text": "宝鸡市",
					"value": "610300"
				},
				{
					"text": "咸阳市",
					"value": "610400"
				},
				{
					"text": "渭南市",
					"value": "610500"
				},
				{
					"text": "延安市",
					"value": "610600"
				},
				{
					"text": "汉中市",
					"value": "610700"
				},
				{
					"text": "榆林市",
					"value": "610800"
				},
				{
					"text": "安康市",
					"value": "610900"
				},
				{
					"text": "商洛市",
					"value": "611000"
				}
			]
		},
		{
			"text": "甘肃省",
			"value": "620000",
			"children": [
				{
					"text": "兰州市",
					"value": "620100"
				},
				{
					"text": "嘉峪关市",
					"value": "620200"
				},
				{
					"text": "金昌市",
					"value": "620300"
				},
				{
					"text": "白银市",
					"value": "620400"
				},
				{
					"text": "天水市",
					"value": "620500"
				},
				{
					"text": "武威市",
					"value": "620600"
				},
				{
					"text": "张掖市",
					"value": "620700"
				},
				{
					"text": "平凉市",
					"value": "620800"
				},
				{
					"text": "酒泉市",
					"value": "620900"
				},
				{
					"text": "庆阳市",
					"value": "621000"
				},
				{
					"text": "定西市",
					"value": "621100"
				},
				{
					"text": "陇南市",
					"value": "621200"
				},
				{
					"text": "临夏回族自治州",
					"value": "622900"
				},
				{
					"text": "甘南藏族自治州",
					"value": "623000"
				}
			]
		},
		{
			"text": "青海省",
			"value": "630000",
			"children": [
				{
					"text": "西宁市",
					"value": "630100"
				},
				{
					"text": "海东市",
					"value": "630200"
				},
				{
					"text": "海北藏族自治州",
					"value": "632200"
				},
				{
					"text": "黄南藏族自治州",
					"value": "632300"
				},
				{
					"text": "海南藏族自治州",
					"value": "632500"
				},
				{
					"text": "果洛藏族自治州",
					"value": "632600"
				},
				{
					"text": "玉树藏族自治州",
					"value": "632700"
				},
				{
					"text": "海西蒙古族藏族自治州",
					"value": "632800"
				}
			]
		},
		{
			"text": "宁夏回族自治区",
			"value": "640000",
			"children": [
				{
					"text": "银川市",
					"value": "640100"
				},
				{
					"text": "石嘴山市",
					"value": "640200"
				},
				{
					"text": "吴忠市",
					"value": "640300"
				},
				{
					"text": "固原市",
					"value": "640400"
				},
				{
					"text": "中卫市",
					"value": "640500"
				}
			]
		},
		{
			"text": "新疆维吾尔自治区",
			"value": "650000",
			"children": [
				{
					"text": "乌鲁木齐市",
					"value": "650100"
				},
				{
					"text": "克拉玛依市",
					"value": "650200"
				},
				{
					"text": "吐鲁番市",
					"value": "650400"
				},
				{
					"text": "哈密市",
					"value": "650500"
				},
				{
					"text": "昌吉回族自治州",
					"value": "652300"
				},
				{
					"text": "博尔塔拉蒙古自治州",
					"value": "652700"
				},
				{
					"text": "巴音郭楞蒙古自治州",
					"value": "652800"
				},
				{
					"text": "阿克苏地区",
					"value": "652900"
				},
				{
					"text": "克孜勒苏柯尔克孜自治州",
					"value": "653000"
				},
				{
					"text": "喀什地区",
					"value": "653100"
				},
				{
					"text": "和田地区",
					"value": "653200"
				},
				{
					"text": "伊犁哈萨克自治州",
					"value": "654000"
				},
				{
					"text": "塔城地区",
					"value": "654200"
				},
				{
					"text": "阿勒泰地区",
					"value": "654300"
				},
				{
					"text": "石河子市",
					"value": "659001"
				},
				{
					"text": "阿拉尔市",
					"value": "659002"
				},
				{
					"text": "图木舒克市",
					"value": "659003"
				},
				{
					"text": "五家渠市",
					"value": "659004"
				},
				{
					"text": "北屯市",
					"value": "659005"
				},
				{
					"text": "铁门关市",
					"value": "659006"
				},
				{
					"text": "双河市",
					"value": "659007"
				},
				{
					"text": "可克达拉市",
					"value": "659008"
				},
				{
					"text": "昆玉市",
					"value": "659009"
				},
				{
					"text": "胡杨河市",
					"value": "659010"
				},
				{
					"text": "新星市",
					"value": "659011"
				},
				{
					"text": "白杨市",
					"value": "659012"
				}
			]
		}
	]
}
